/**
 * Photo / legal identification numbers: Unicode letters and digits, plus ASCII hyphen (-) only.
 * Spaces and all other characters (including other punctuation) are removed as the user types.
 */

export const IDENTIFICATION_NUMBER_MAX_LENGTH = 20;

const ID_NUMBER_ALLOWED = /^[\p{L}\p{N}\-]+$/u;

/** Removes everything except letters, numbers, and hyphen; caps length. */
export function sanitizeIdentificationNumberInput(value: string): string {
	const cleaned = value.replace(/[^\p{L}\p{N}\-]/gu, "");
	return cleaned.slice(0, IDENTIFICATION_NUMBER_MAX_LENGTH);
}

/** True when trimmed value is non-empty, within max length, and contains only letters, numbers, and hyphens. */
export function isIdentificationNumberContentValid(value: string): boolean {
	const t = value.trim();
	if (!t) return false;
	if (t.length > IDENTIFICATION_NUMBER_MAX_LENGTH) return false;
	return ID_NUMBER_ALLOWED.test(t);
}

/** GFF/additional-field XmlTags that collect photo or legal ID numbers (Bill Pay additional info). */
export function isIdentificationNumberFieldKey(key: string): boolean {
	const k = String(key ?? "").trim();
	return (
		k === "senderPhotoIdNumber" ||
		k === "receiverPhotoIdNumber" ||
		k === "senderLegalIdNumber" ||
		k === "receiverLegalIdNumber" ||
		k === "thirdPartyPhotoIdNumber" ||
		k === "thirdPartyLegalIdNumber"
	);
}
